<div class="container">
  <h4>Camera Alert</h4>
  <form #alertForm="ngForm" (ngSubmit)="alertForm.form.valid && saveAlert()">
    <div class="row row-cols-1 row-cols-md-3">
      <!-- Alert Name -->
      <div class="col mb-3">
        <label for="txtName">Alert Name</label
        ><input
          #txtName="ngModel"
          [(ngModel)]="alertModel.Name"
          type="text"
          id="txtName"
          name="txtName"
          class="form-control"
          [disabled]="!isReady"
          required
          pattern="^[a-zA-Z\d\-]+$" />
        @if (invalidName) {
          <small class="text-danger">Alert name is already in use.</small>
        }
        @if (
          ((txtName.touched && txtName.dirty) || alertForm.submitted) &&
          txtName.errors?.required
        ) {
          <small class="text-danger">Name is required</small>
        }
        @if (
          ((txtName.touched && txtName.dirty) || alertForm.submitted) &&
          txtName.errors?.pattern
        ) {
          <small class="text-danger">Letters and numbers only, no spaces</small>
        }
      </div>

      <!-- Select Site -->
      <div class="col mb-3">
        <label for="cboSite">Select Site</label
        ><select
          #cboSite="ngModel"
          name="cboSite"
          [(ngModel)]="selectedSite"
          id="cboSite"
          class="form-control form-select"
          [disabled]="!isReady"
          (change)="changeSite()">
          @for (site of this.sites; track site; let i = $index) {
            <option [ngValue]="site">
              {{ site.Name }}
            </option>
          }
        </select>
      </div>

      <!-- Enabled -->
      <div class="col pb-2 d-flex align-items-center">
        <div class="form-check form-switch custom-switch-info">
          <input
            #chkEnabled="ngModel"
            [(ngModel)]="alertModel.Enabled"
            type="checkbox"
            class="form-check-input"
            id="chkEnabled"
            name="chkEnabled"
            [disabled]="!isReady" />
          <label class="form-check-label" for="chkEnabled">Enabled</label>
        </div>
      </div>
    </div>

    <!-- Trigger Camera -->
    <div class="row row-cols-1 row-cols-md-3">
      <div class="col mb-3">
        <label for="cboTrigger">Trigger Camera</label
        ><select
          #cboTrigger="ngModel"
          [(ngModel)]="alertModel.TriggerId"
          [disabled]="!isReady || selectedSite === null"
          name="cboTrigger"
          id="cboTrigger"
          class="form-control form-select">
          @for (camera of triggerCameras; track camera; let i = $index) {
            <option [ngValue]="camera.Id">
              {{ camera.Name }}
            </option>
          }
        </select>
      </div>

      <!-- Event Type -->
      <div class="col mb-3">
        <label for="cboType">Event Type</label
        ><select
          #cboType="ngModel"
          [(ngModel)]="alertModel.AlertType"
          name="cboType"
          id="cboType"
          class="form-control form-select"
          [disabled]="!isReady">
          <option [ngValue]="1">Heat</option>
          <option [ngValue]="2">Motion</option>
        </select>
      </div>

      <!-- Peer Camera -->
      <div class="col mb-3">
        <label for="cboPeer">Peer Camera</label>
        <div class="input-group">
          <select
            #cboPeer="ngModel"
            [(ngModel)]="alertModel.PeerId"
            [disabled]="!isReady || selectedSite === null"
            name="cboPeer"
            id="cboPeer"
            class="form-control form-select">
            @for (
              camera of selectedSite?.Cameras;
              track camera;
              let i = $index
            ) {
              <option [ngValue]="camera.Id">
                {{ camera.Name }}
              </option>
            }
          </select>
          <span
            class="input-group-text"
            role="button"
            (click)="clearPeerCamera()">
            <fa-icon [icon]="icons.times"></fa-icon>
          </span>
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <div class="row">
      <div class="col text-end">
        @if (!isNew) {
          <button
            type="button"
            [disabled]="!isReady || !adminService.isReady"
            class="btn btn-warning btn-sm ms-1"
            (click)="testAlert()">
            Test Alert
          </button>
        }
        @if (!isNew) {
          <button
            type="button"
            [disabled]="!isReady || !adminService.isReady"
            class="btn btn-sm btn-outline-danger ms-1"
            (click)="deleteAlert()">
            Delete
          </button>
        }
        <button
          type="button"
          [routerLink]="['/admin', 'alerts']"
          class="btn btn-secondary btn-sm ms-1">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="!isReady || !adminService.isReady || !alertForm.valid"
          class="btn btn-primary btn-sm ms-1">
          Save
        </button>
      </div>
    </div>

    <div class="p-3">
      <ngb-alert
        type="info"
        [hidden]="!isAlertSending"
        (close)="isAlertSending = false"
        [dismissible]="false">
        <fa-icon animation="spin-pulse" [icon]="icons.spinner"></fa-icon>
        {{ alertMessage }}
      </ngb-alert>
    </div>

    <div>
      <ngb-alert
        type="success"
        [hidden]="!isAlertSendingSuccess"
        (close)="isAlertSendingSuccess = false"
        [dismissible]="false">
        <fa-icon [icon]="icons.check"></fa-icon>
        {{ alertMessage }}
      </ngb-alert>
    </div>

    <div class="row">
      <div class="col">
        <app-user-picker caption="Select Recipients" [(users)]="users">
        </app-user-picker>
      </div>
    </div>
  </form>
</div>
